import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

import { IdName } from '@shared/models/id-name';
import { BaseDestroyableDirective } from '@shared/base-classes/base-destroyable';
import { FavoritesEnum } from '@shared/models/enums/favorites.enum';
import { FavoriteSelectorComponent } from '@shared/components/favorite-selector/favorite-selector.component';
import { SelectComponent } from '@shared/components/select/select.component';

import { EMPTY_INTUITIVE_IMPLANTS_FORM_VALUE, IntuitiveImplantsFormValue } from './implants-form.model';

@Component({
	selector: 'rx-intuitive-implants-form',
	templateUrl: './rx-intuitive-implants-form.component.html',
	styleUrls: ['./rx-intuitive-implants-form.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, ReactiveFormsModule, TranslateModule, FavoriteSelectorComponent, SelectComponent]
})
export class RxIntuitiveImplantsFormComponent extends BaseDestroyableDirective implements OnInit, OnChanges {
	@Input() formValue: IntuitiveImplantsFormValue = EMPTY_INTUITIVE_IMPLANTS_FORM_VALUE;
	@Input() scanBodyManufacturerOptions: IdName[] = [];
	@Input() implantManufacturerOptions: IdName[] = [];
	@Input() implantTypeScanBodyOptions: IdName[] = [];
	@Input() shouldValidateForSend = false;
	@Input() isProcedureFlow = false;
	@Input() isFavoritesHidden = false;

	@Output() formValueChange = new EventEmitter<IntuitiveImplantsFormValue>();

	readonly favoriteScanBody = FavoritesEnum.ScanBodies;
	readonly favoriteImplant = FavoritesEnum.Implants;

	manufactureForm = this.formBuilder.group<IntuitiveImplantsFormValue>({
		scanBodyManufacturer: null,
		implantManufacturer: null,
		implantTypeScanBody: null
	});

	get scanBodyManufacturerControl() {
		return this.manufactureForm.controls.scanBodyManufacturer;
	}

	get implantManufacturerControl() {
		return this.manufactureForm.controls.implantManufacturer;
	}

	get implantTypeScanBodyControl() {
		return this.manufactureForm.controls.implantTypeScanBody;
	}

	constructor(private readonly formBuilder: FormBuilder) {
		super();
	}

	ngOnInit(): void {
		this.manufactureForm.patchValue(this.formValue, { emitEvent: false });

		this.manufactureForm.valueChanges.pipe(takeUntil(this.componentAlive$)).subscribe(() => {
			this.formValueChange.emit(this.manufactureForm.getRawValue() as IntuitiveImplantsFormValue);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.formValue) {
			this.manufactureForm.patchValue(this.formValue, { emitEvent: false });
		}
	}
}
